import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";

import { LocalizeService } from "../../insa-services";
import {
  ControlTableService,
  EODHDRealTimeResponseModel,
} from "./control-table.service";
import { ControlTableSecurity } from "./control-table.models";

@Component({
  selector: "app-control-table-depth-modal",
  templateUrl: "./control-table-depth-modal.component.html",
  styles: [require("./control-table.component.css").toString()],
  encapsulation: ViewEncapsulation.None,
})
export class ControlTableDepthModalComponent implements OnInit, OnDestroy {
  @Input() security: ControlTableSecurity | null = null;
  @Output() closed = new EventEmitter<void>();

  levels: EODHDRealTimeResponseModel[] = [];
  loading = true;

  private pollInterval: any;

  constructor(
    private _localize: LocalizeService,
    private _element: ElementRef,
    private _service: ControlTableService,
  ) {}

  ngOnInit(): void {
    this.load();
    this.pollInterval = setInterval(() => this.load(), 5000);
    setTimeout(
      () => this._localize.applyTranslations(this._element.nativeElement),
      0,
    );
  }

  ngOnDestroy(): void {
    if (this.pollInterval) clearInterval(this.pollInterval);
  }

  get symbol(): string {
    if (!this.security) return "";
    return (
      this.security.SecSymbol?.trim() || this.security.SecNumber?.trim() || ""
    );
  }

  get pairedRows(): {
    bidPrice: number | null;
    bidQty: number | null;
    askPrice: number | null;
    askQty: number | null;
  }[] {
    return this.levels
      .map((item) => ({
        bidPrice: item.bid != null && item.bid > 0 ? item.bid : null,
        bidQty:
          item.bid != null && item.bid > 0 ? (item.bidQuantity ?? 0) : null,
        askPrice: item.ask != null && item.ask > 0 ? item.ask : null,
        askQty:
          item.ask != null && item.ask > 0 ? (item.askQuantity ?? 0) : null,
      }))
      .filter((r) => r.bidPrice !== null || r.askPrice !== null);
  }

  private load(): void {
    if (!this.security) return;
    this._service.realTimeL2(this.security).subscribe((data) => {
      this.loading = false;
      this.levels = data ?? [];
    });
  }

  close(): void {
    this.closed.emit();
  }

  formatN(value: number | null | undefined, decimals = 2): string {
    if (value === null || value === undefined || isNaN(value as number))
      return "";
    return (kendo as any).toString(value, "n" + decimals);
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-control-table/control-table-depth-modal.component.ts